'use strict'

class ContactFormCtrl {
    constructor ($http, $state, $rootScope, $stateParams, $mdToast, Contact, $mdDialog) {

        //Turn providers into class variables
        this.$rootScope = $rootScope
        this.$state = $state
        this.$stateParams = $stateParams
        this.$http = $http
        this.$mdToast = $mdToast
        this._Contact = Contact
        this.$mdDialog = $mdDialog

        //Variable declarables
        this.customFieldsRaw = []
        this.customFields = {}
        this.formdata = { tags: [] }
        this.buttonDisabled = false
        this.showCancelButton = !$state.includes('contacts')
        this.checkForRelatedContacts = {}

        //If there's an id get information (Update)
        if ($stateParams.contactId) {
            this.getModelTypes().then(() => {
                return this.$http.get('/contacts/' + $stateParams.contactId)
            }).then(result => {
                angular.extend(this.formdata, result.data)
            })
        } else {
            this.getModelTypes().then(() => {
                this.formdata.model_type_id = this.customFieldsRaw[0].id
            })
        }

        if ($stateParams.name) {
            let name = $stateParams.name.split(/\s+/)
            this.formdata.firstname = name[0]
            this.formdata.lastname = name.slice(1).join(' ')
        }

        this.checkRelatedContacts = () => {
            this.checkForRelatedContacts.update()
        }

        this.getContactUrl = function () {
            if (this.formdata.firstname && this.formdata.lastname) {
                if (this.formdata.firstname.length > 3) {
                    let contactId
                    if (this.formdata.id) {
                        contactId = this.formdata.id
                    } else {
                        contactId = 0
                    }
                    let firstName = encodeURIComponent(this.formdata.firstname.replace('/', ''))
                    let lastName = encodeURIComponent(this.formdata.lastname.replace('/', ''))
                    let url = '/contacts/unique_contact/' + firstName + ' ' + lastName + '/' + contactId
                    return url
                }
            }
        }.bind(this)

    }

    getModelTypes () {
        return this.$http.get('/modeltypes/contact', { cache: true }).then((response) => {
            this.customFieldsRaw = response.data.contact
            response.data.contact.forEach((data) => {
                this.customFields[data.id] = data.fields
            })
            return response.data
        })
    }

    makeDate (date) {
        return date ? new Date(date) : new Date()
    }

    cancel () {
        this.$state.go('^')
    }

    save ($valid) {
        //Check if form is valid
        if (!$valid) {
            return
        }

        //Disable button
        this.buttonDisabled = true

        //Save contact object
        this._Contact.save(this.formdata, (data) => {
            //Get the right type
            let type = this.formdata.id ? 'saved' : 'create'

            //Show notifications
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.' + type + '?object=contact&title=' + this.formdata.firstname + '%20' + this.formdata.lastname,  //@trans('labels.contact')
                hideDelay: 3000,
                position: ('top right')
            })

            if (!this.$state.includes('contacts')) {
                //Broadcast contact (back to item view)
                this.$rootScope.$broadcast('item_contact_updated', data)

                //Return to previous view
                this.$state.go('^')

            } else {
                //Reload update view
                this.$state.go('contacts.update', { contactId: data.id }, { 'reload': true })
            }
        })
    }

    showRevisions (ev) {
        this.$http.get('/revisions/contacts/' + this.$stateParams.contactId).then(revisions => {
            this.$mdDialog.show({
                controller: 'RevisionDialogCtrl',
                templateUrl: 'revisionDialog.ngTemplate',
                parent: angular.element(document.querySelector('#popupContainer')),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    revisions: revisions.data
                }
            }).then((values) => {
                this.formdata.model_type_id = values.model_type_id
                this.formdata.firstname = values.firstname
                this.formdata.lastname = values.lastname
                this.formdata.email = values.email
                this.formdata.phone = values.phone
                this.formdata.tags = values.tags
                this.formdata.field_values = JSON.parse(values.field_values)
            }).catch(() => {})
        })
    }

    tagSearch (query) {
        return this.$http.get('/tags/search/' + encodeURIComponent(query)).then(result => {
            return result.data
        })
    }
}

ContactFormCtrl.$inject = ['$http', '$state', '$rootScope', '$stateParams', '$mdToast', 'Contact', '$mdDialog']

module.exports = ContactFormCtrl
